import {
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import {useDialog, useTranslate} from '../../../hooks';
import {BaseDialog} from '@resurs-internal/mui';
import {Trans} from 'react-i18next';

import {IconBadge} from '../../../components';

export const PreCollectionDialog = () => {
  const theme = useTheme();
  const translate = useTranslate();
  const dialog = useDialog('pre-collection');

  return (
    <BaseDialog
      open={dialog.open}
      onClose={dialog.onClose}
      maxWidth={'md'}
      actions={[
        {
          title: translate('common.close'),
          onClick: dialog.onClose,
        },
      ]}>
      <DialogContent>
        <Stack direction={'column'} my={2} alignItems={'center'}>
          <IconBadge
            type={'font'}
            icon={'circle-exclamation'}
            size={'xl'}
            color={theme.palette.error.main}
          />
          <DialogTitle variant={'h4'} component={'h1'} textAlign={'center'}>
            {translate('dialogs.billing.late-payment.title')}
          </DialogTitle>
          <Typography variant={'body1'} whiteSpace={'break-spaces'}>
            <Trans
              i18nKey="dialogs.billing.late-payment.subtitle"
              components={{
                bold: <strong />,
              }}
            />
          </Typography>
        </Stack>
      </DialogContent>
    </BaseDialog>
  );
};
